import type { CogfyClient } from '@indigohive/cogfy-api-client'
import { useContext } from 'react'
import { CogfyClientContext } from '../contexts'

export function useCogfy (): CogfyClient {
  return useContext(CogfyClientContext)
}
